<template>
  <v-container style="width: 100%">
    <v-row>
      <v-col></v-col>
      <v-col cols="auto">

        <v-btn color="primary" @click="composeDialog = true" class="t-compose-btn">{{ $t('notifications.sendMessage') }}</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs grow v-model="direction" class="t-notifications-tabs">
        <v-tab>{{ $t('notifications.dir.in') }}</v-tab>
        <v-tab>{{ $t('notifications.dir.out') }}</v-tab>
      </v-tabs>
    </v-row>


    <v-list
        style="width: 100%"
        v-infinite-scroll="loadNotifications"
        :infinite-scroll-disabled="loading || allLoaded"
    >
      <NotificationsListItem
          v-for="(ntf,i) in visibleNotificationsList"
          :key="i"
          :notification="ntf"
          @click="openNotification(ntf)"
      />

      <v-list-item disabled v-if="!allLoaded">
        <v-list-item-content>
          <div class="text-center">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog
        :value="replyTo !== null"
        @click:outside="replyTo = null"
        :max-width="$vuetify.breakpoint.mobile ? '95%' : '50%'"
    >
      <ReplyDialog
          :notification="replyTo"
          @close="replyTo = null"
          v-if="replyTo !== null"
          @send="onReplySend"
      />
    </v-dialog>

    <v-dialog v-model="composeDialog" :max-width="$vuetify.breakpoint.mobile ? '95%' : '50%'">
      <ComposeDialog
        @close="composeDialog = false"
        @send="onSendMessage"
        v-if="composeDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable newline-per-chained-call */
/* eslint-disable no-mixed-operators */

import NotificationsListItem from "./NotificationsListItem";
import ReplyDialog from "./ReplyDialog";
import ComposeDialog from './ComposeDialog';
import infiniteScroll from 'vue-infinite-scroll'
import {mapActions, mapGetters} from "vuex";
import RightsholderInitedDataDrivenMixin from "@/components/mixins/RightsholderInitedDataDrivenMixin";
import {NOTIFICATIONS_POLL_INTERVAL} from "@/plugins/store/constants";

export default {

  name: "NotificationsPanel",
  components: {
    NotificationsListItem,
    ReplyDialog,
    ComposeDialog,
  },
  directives: {
    infiniteScroll
  },
  data: () => ({
    currentPage: 0,
    replyTo: null,
    composeDialog: false,
    loading: false,
    notifications: [],
    direction: 0
  }),
  computed: {
    ...mapGetters('app', ['isAuthenticated', 'isAdmin', 'currentRightsholder', 'notificationsList','notificationsPollingInterval']),
    allLoaded() {
      return this.$store.getters["app/notifications"].finished;
    },
    visibleNotificationsList() {
      const f = (dir) => (dir === ['IN', 'OUT'][this.direction]);
      return this.notificationsList ? this.notificationsList.filter(({direction}) => f(direction)) : [];
    },
    currentRightsholderId() {
      return this.currentRightsholder.id;
    }
  },
  mixins: [RightsholderInitedDataDrivenMixin],

  methods: {
    ...mapActions('app', ['setNotificationsPollingInterval', 'stopNotificationsPoll']),
  
    launchNotificationsPoll() {
      if (this.notificationsPollingInterval) {
        return;
      }

      let interval
      interval = setTimeout(() => {
        this.$store.dispatch('app/pollLoadNotifications')
          .then((res) => {
            interval = null;
            this.launchNotificationsPoll();

            if (res.result > 0) {
              this.$toast(this.$t('noitifcations.newMessages', [res.result]))
            }
          })
          .catch(() => {
            interval = null;
            this.launchNotificationsPoll();
          })
      }, NOTIFICATIONS_POLL_INTERVAL);
      this.setNotificationsPollingInterval(interval)
    },

    reloadItems() {
      this.stopNotificationsPoll().then(() => {
        this.loadNotificationsList(true)
          .then(() => {
            this.launchNotificationsPoll()
          });
      })
    },

    onSendMessage(data) {
      this.$store.dispatch('app/sendNotificationToAdmin', {text: data.text, title: data.title}).then(() => {
        this.$toast(this.$t('notifications.messageSent'));
        this.composeDialog = false;
      }).catch((res) => {
        this.$toast(res.response.data.errorMsg.En);
      })
    },

    onReplySend(data) {
      this.$store.dispatch('app/sendNotificationReply', {
        mid: this.replyTo.id,
        title: `Re: ${this.replyTo.messageHead}`,
        text: data.text,
      })
        .then(() => {
          this.$toast(this.$t('notifications.messageSent'));
          this.replyTo = null;
        })
        .catch((res) => {
          this.$toast(res.response.data.errorMsg.En);
        })
    },

    loadNotifications() {
      if (this.allLoaded || this.loading) {
        return;
      }
      this.loading = true;
      this.loadNotificationsList().then(() => {
        this.loading = false;
      })
    },

    loadNotificationsList(force = false) {
      if (!this.$store.getters["app/currentRightsholder"].id) {
        return Promise.resolve([]);
      }
      return this.$store.dispatch('app/loadNotifications', {force})
        .catch((res) => {
          this.$toast(res instanceof Error ? res.message : res.response.data.errorMsg.En);
        });
    },

    openNotification(ntf) {
      this.replyTo = ntf;
      if (!ntf.isRead) {
        this.$store.dispatch('app/markMessageRead', ntf.id);
      }
    }
  },
};
</script>